import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state && location.state.registered) {
      setSuccessMessage('Registration successful! Please log in.');
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      if (!res.ok) {
        setError('Invalid email or password');
        return;
      }

      const data = await res.json();
      localStorage.setItem('token', data.access_token);

      // 🔄 Взимаме потребителското име чрез /me и го запазваме
      const meRes = await fetch(`${process.env.REACT_APP_API_URL}/me`, {
        headers: {
          Authorization: `Bearer ${data.access_token}`
        }
      });

      if (meRes.ok) {
        const userData = await meRes.json();
        localStorage.setItem('username', userData.username);
      }

      navigate('/chat');
    } catch (err) {
      console.error('Login error:', err);
      setError('An unexpected error occurred');
    }
  };

  return (
    <div className="flex items-center justify-center h-screen bg-[#140D4F]">
      <form onSubmit={handleLogin} className="bg-white p-8 rounded-2xl shadow-xl w-96">
        <h1 className="text-[#140D4F] text-3xl font-bold text-center mb-2">
          <Link to="/" className="hover:underline">DiagCode.AI</Link>
        </h1>
        <p className="text-gray-600 text-sm text-center mb-6">
          Your assistant for advanced vehicle diagnostics and repair insights.
        </p>

        <h2 className="text-[#140D4F] text-2xl font-semibold mb-4 text-center">Login</h2>
        {successMessage && <p className="text-green-400 text-sm mb-4 text-center">{successMessage}</p>}
        {error && <p className="text-red-400 text-sm mb-4 text-center">{error}</p>}

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 mb-4 rounded border border-gray-300 text-black placeholder-gray-500"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 mb-4 rounded border border-gray-300 text-black placeholder-gray-500"
        />
        <button
          type="submit"
          className="w-full bg-[#FD5003] hover:bg-[#e34700] text-white py-2 rounded font-semibold transition"
        >
          Login
        </button>
        <p className="text-gray-300 text-sm mt-4 text-center">
          Don’t have an account? <a href="/register" className="text-[#0267C1] hover:underline">Register</a>
        </p>
      </form>
    </div>
  );
};

export default Login;
